import { getBlock, saveBlock } from '@/api/blocks';
import { BlockEditorState } from '@/types/block';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type BlockGetter = GetterTree<BlockEditorState, RootState>;

const getDefaultState = (): BlockEditorState => ({
  id: null,
  title: null,
  slug: null,
  description: null,
  content: '',
  created_at: null,
  updated_at: null,
});

const state: BlockEditorState = getDefaultState();

const getters: BlockGetter = {
  page: state => state,
};

const actions: ActionTree<BlockEditorState, RootState> = {
  async getBlock({ commit }, id) {
    commit('setBlock', await getBlock(id));
  },
  async saveBlock({ state, commit, dispatch }) {
    try {
      const block = await saveBlock(state);
      commit('setBlock', block);
      dispatch('notifications/success', 'Block saved', { root: true });
    } catch (e) {
      dispatch(
        'notifications/error',
        'There was an error trying to save the block',
        { root: true },
      );
    }
  },
  resetEditor({ commit }) {
    commit('resetBlockEditor');
  },
};

const mutations: MutationTree<BlockEditorState> = {
  resetBlockEditor(blockEditorState: BlockEditorState): void {
    Object.assign(blockEditorState, getDefaultState());
  },
  setBlock(blockEditorState: BlockEditorState, page: BlockEditorState): void {
    blockEditorState = Object.assign(blockEditorState, page);
  },
  setBlockTitle(blockEditorState: BlockEditorState, title: string): void {
    blockEditorState.title = title;
  },
  setBlockSlug(blockEditorState: BlockEditorState, slug: string): void {
    blockEditorState.slug = slug;
  },
  setBlockDescription(
    blockEditorState: BlockEditorState,
    description: string,
  ): void {
    blockEditorState.description = description;
  },
  setBlockContent(blockEditorState: BlockEditorState, content: string): void {
    blockEditorState.content = content;
  },
};

const blockEditor: Module<BlockEditorState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default blockEditor;
